import { computed, Ref, ref, ComputedRef } from '@nuxtjs/composition-api';

const seconds: Ref<number> = ref(0);

const currentCountdown = ref();

export const timeRemaining: ComputedRef<number> = computed(() => seconds.value);

const startCountdown = (time: number): void => {
  if (currentCountdown.value) {
    clearInterval(currentCountdown.value);
  }
  seconds.value = time;

  currentCountdown.value = setInterval(() => {
    if (seconds.value) {
      seconds.value -= 1000;
    }
    if (!seconds.value) {
      clearInterval(currentCountdown.value);
    }
  }, 1000);
};

export default startCountdown;
